package com.dotdrives.web.pages.givers

import com.dotdrives.model.ActivityEvent
import com.dotdrives.web.ui.DotPill
import react.FC
import react.Key
import react.Props
import react.dom.html.ReactHTML.div
import web.cssom.ClassName

external interface TimelineListProps : Props {
    var items: List<ActivityEvent>
}

val TimelineList = FC<TimelineListProps> { props ->
    if (props.items.isEmpty()) {
        div {
            className = ClassName("givers-empty-copy")
            +"No activity yet."
        }
    } else {
        div {
            className = ClassName("givers-timeline")
            props.items.forEach { event ->
                val presentation = timelinePresentation(
                    verb = event.verb,
                    payload = mapOf(
                        "title" to event.payload["title"].payloadText(),
                        "snippet" to event.payload["snippet"].payloadText(),
                    ).filterValues(String::isNotBlank),
                )
                val tone = timelineTone(event.verb)
                div {
                    key = event.id.unsafeCast<Key>()
                    className = ClassName("givers-timeline-item")
                    div {
                        className = ClassName("givers-timeline-dot")
                        +presentation.icon
                    }
                    div {
                        className = ClassName("givers-timeline-title-row")
                        div {
                            className = ClassName("givers-timeline-title")
                            +"${presentation.icon} ${presentation.title}"
                        }
                        div {
                            className = ClassName("givers-timeline-meta")
                            div {
                                className = ClassName("givers-timeline-date")
                                +formatTimelineDate(event.occurredAt.toString())
                            }
                            DotPill {
                                text = tone.label
                                this.tone = tone.tone
                                className = "givers-timeline-tone"
                            }
                        }
                    }
                    presentation.body?.takeIf(String::isNotBlank)?.let { body ->
                        div {
                            className = ClassName("givers-timeline-body")
                            +body
                        }
                    }
                }
            }
        }
    }
}

private fun Any?.payloadText(): String =
    this?.toString()?.removeSurrounding("\"").orEmpty()

internal fun formatTimelineDate(instant: String): String =
    instant.substringBefore('T').ifBlank { instant }
